import { z } from "zod/v4";

import { BillingCommandBillingRegimeList } from "./commands/catalog";
import { SubscriptionBillingProviderList } from "../subscriptions";
import { BillingCatalogVersionList } from "../../schemas/stripe";

export const BillingRoutingWarningCodeList = [
  "billing_regime_missing_defaulted_to_stripe_v2",
  "stripe_subscription_link_missing",
  "stripe_subscription_link_multiple_candidates",
  "catalog_version_missing",
  "catalog_version_malformed",
  "raw_catalog_version_mismatch",
] as const;

export type BillingRoutingWarningCode =
  (typeof BillingRoutingWarningCodeList)[number];

export const BillingRoutingConflictCodeList = [
  "modular_requires_2026_module_v1",
  "regime_catalog_version_mismatch",
] as const;

export type BillingRoutingConflictCode =
  (typeof BillingRoutingConflictCodeList)[number];

export const BillingContextSchema = z.object({
  orgId: z.uuid(),
  billingRegime: z.enum(BillingCommandBillingRegimeList),
  stripeSubscriptionLinkId: z.uuid().nullable(),
  billingProvider: z.enum(SubscriptionBillingProviderList).nullable(),
  catalogVersion: z.enum(BillingCatalogVersionList).nullable(),
  routingWarnings: z.enum(BillingRoutingWarningCodeList).array(),
  isConflict: z.boolean(),
  conflictCode: z.enum(BillingRoutingConflictCodeList).nullable(),
});

export type BillingContext = z.infer<typeof BillingContextSchema>;
